import { render, staticRenderFns } from "./client_detail.vue?vue&type=template&id=364c4aa1&scoped=true&"
import script from "./client_detail.vue?vue&type=script&lang=js&"
export * from "./client_detail.vue?vue&type=script&lang=js&"
import style0 from "./client_detail.vue?vue&type=style&index=0&id=364c4aa1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364c4aa1",
  null
  
)

export default component.exports